export const GET_REQUIREMENT = 'REQUIREMENT/get_requirement';
export const GET_SINGLE_MODULE = 'MODULE/GET_SINGLE_MODULE';
export const UPDATE_REQUIREMENT = 'REQUIREMENT/update_requirement';
export const CREATE_REQUIREMENT = 'REQUIREMENT/create_requirement';
export const REMOVE_REQUIREMENT = 'REQUIREMENT/remove_requirement';
export const GET_TAG = 'REQUIREMENT/get_tag';
export const REMOVE_TAG = 'REQUIREMENT/remove_tag';
export const TAG = 'REQUIREMENT/tag';
export const GET_APPLICATION_STATUS = 'REQUIREMENT/get_applicantion_status';

export const CREATE_APPLICATION_STATUS = 'MODULE_SYSTEM/create_application_status';
export const UPDATE_APPLICATION_STATUS = 'MODULE_SYSTEM/update_application_status';
export const REMOVE_APPLICATION_STATUS = 'MODULE_SYSTEM/remove_application_status';

export const FORM_DATA = {
  name: '',
  photo: '',
  sequence: '',
  description: '',
  description_2: '',
  description_filipino: '',
  other_information: '',
  is_active: '',
  is_coming_soon: false,
  category: '',
};

export const categoryOptions = [
  { label: 'E-Government', value: 'E-Government' },
  { label: 'E-Services', value: 'E-Services' },
];
